<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="100px" :rules="rules" ref="dialogForm">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-card>
            <span slot="header" class="title">门店信息</span>
            <el-form-item label="门店名称" prop="shop_name">
              <el-input v-model.trim="dialogForm.shop_name" autocomplete="off" clearable maxLength="18"></el-input>
            </el-form-item>
            <el-form-item label="门店类型" prop="shop_type">
              <shop-type-select v-model="dialogForm.shop_type" clearable/>
            </el-form-item>
            <el-form-item label="门店地区" prop="shop_region">
              <region-cascade v-model="dialogForm.shop_region" clearable/>
            </el-form-item>
            <el-form-item label="门店电话" prop="shop_telephone">
              <el-input v-model.trim="dialogForm.shop_telephone" autocomplete="off" clearable maxLength="13"></el-input>
            </el-form-item>
            <el-form-item label="门店邮箱" prop="shop_email">
              <el-input v-model.trim="dialogForm.shop_email" autocomplete="off" clearable></el-input>
            </el-form-item>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card>
            <span slot="header" class="title">管理员信息</span>
            <el-form-item label="用户名" prop="username">
              <el-input v-model.trim="dialogForm.username" autocomplete="off" clearable maxLength="18"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input type="password" v-model.trim="dialogForm.password" autocomplete="off" clearable maxLength="14"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="repassword">
              <el-input type="password" v-model.trim="dialogForm.repassword" autocomplete="off" clearable maxLength="14"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model.trim="dialogForm.mobile" autocomplete="off" clearable maxLength="11"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model.trim="dialogForm.email" autocomplete="off" clearable></el-input>
            </el-form-item>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,changeEmpty,checkUsername,checkPwd,checkTelephone,checkMobile,checkNickName,checkPureNumber,checkMailbox} from '@utils/validate'
  import RegionCascade from "@view/components/cascader/RegionCascade"
  import ShopTypeSelect from "@view/components/select/ShopTypeSelect"
  export default {
    name: "AddShop",
    components: {RegionCascade,ShopTypeSelect},
    props: {dialogData: Object},
    data() {
      let checkRePass = (rule, value, callback) => {
        if (value !== this.dialogForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        dialogForm: {
          username: "",
          password: "",
          repassword: "",
          mobile: "",
          email: "",
          shop_name: "",
          shop_type: "",
          shop_region: "",
          shop_telephone: "",
          shop_email: "",
        },
        rules: {
          username: [inputEmpty('用户名'), checkPureNumber(), checkUsername()],
          password: [inputEmpty("密码"), checkPwd()],
          repassword: [inputEmpty('确认密码'), {validator: checkRePass, trigger: 'blur'}],
          mobile: [inputEmpty('手机号'), checkMobile()],
          email: [inputEmpty('邮箱'), checkMailbox()],
          shop_name: [inputEmpty("商家门店名"),checkNickName("商家门店名")],
          shop_type: [changeEmpty("商家类型")],
          shop_region: [changeEmpty('商家区域')],
          shop_telephone: [checkTelephone()],
          shop_email: [checkMailbox()],
        },
      }
    },
    methods: {
      confirm() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            let res = await this.$Http.addShop(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
